module.exports = __webpack_public_path__ + "img/outlander_ai.4aa9e6da.jpg";